import getApiClient from 'src/utils/getApiClient'
import type {
  ServiceSlotsRequest,
  ServiceSlotsResponse,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/api/apiServiceSlots.types'

const apiClient = getApiClient()

const apiServiceSlots = {
  post(payload: ServiceSlotsRequest) {
    return apiClient.post<ServiceSlotsResponse>(
      '/ajax/diagnostika/services/schedule/',
      payload,
    )
  },
}

export default apiServiceSlots
